<template>
  <div
    class="modal"
    tabindex="-1"
    aria-hidden="true"
    ref="editUserDataModal"
    data-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content rounded-lg">
        <div class="modal-header justify-end pt-5 pb-0 border-0">
          <a
            data-dismiss="modal"
            href="javascript:;"
            class="font-poppins text-theme-23 font-medium hover:text-theme-35"
          >
            Cerrar
          </a>
        </div>
        <div class="px-10">
          <div class="modal-body pt-0">
            <h1
              class="font-crimson_pro text-theme-9 text-3xl font-bold text-center"
            >
              Editar mi información
            </h1>
            <div class="flex flex-col w-full">
              <div class="intro-x mt-4 flex flex-col">
                <img
                  class="w-20 h-20 rounded-full mx-auto mt-3 mb-4"
                  :src="imageProfile"
                  alt="avatar"
                  crossorigin="anonymous"
                />
                <span
                  class="text-center text-sm cursor-pointer text-theme-9 font-poppins font-semibold"
                  @click="$emit('showModalSetAvatar')"
                >
                  Elegir Avatar
                </span>
              </div>
              <div class="intro-x mt-7">
                <span class="text-xs">Nombre(s)</span>
                <input
                  type="text"
                  class="form-control p-2"
                  placeholder="Nombre(s)"
                  v-model="name"
                />
              </div>
              <div class="intro-x mt-4">
                <span class="text-xs">Apellidos</span>
                <input
                  type="text"
                  class="form-control p-2"
                  placeholder="Apellidos"
                  v-model="lastName"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer text-right">
            <div class="flex flex-col">
              <button
                type="button"
                :disabled="!checkValidation"
                @click="$emit('editUserDataAction', { name, lastName })"
                class="btn btn-quotation rounded-lg px-5 w-full sm:w-9/12 text-base mx-auto"
              >
                Guardar
              </button>
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-quotation-outline rounded-lg px-5 mt-5 mb-3 w-full sm:w-9/12 text-base mx-auto"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imageProfile: {
      type: String
    }
  },
  data() {
    return {
      modal: undefined,
      name: undefined,
      lastName: undefined
    }
  },
  emits: ['editUserDataAction', 'showModalSetAvatar'],
  methods: {
    viewModal(view = 'show') {
      if (view === 'show') {
        this.name = this.$store.state.auth.user?.name
        this.lastName = this.$store.state.auth.user?.last_name
      }
      return cash(this.modal).modal(view)
    }
  },
  mounted() {
    this.modal = this.$refs.editUserDataModal
  },
  computed: {
    checkValidation() {
      return (
        this.name &&
        this.name.length > 2 &&
        this.name.length <= 200 &&
        this.lastName &&
        this.lastName.length > 2 &&
        this.lastName.length <= 200
      )
    }
  }
}
</script>
